import * as React from "react";
export const KeycloakContext = React.createContext(undefined);
